import React, { useState } from 'react';
import { WhatsAppHome } from './WhatsAppHome';
import { WhatsAppQRScanner } from './WhatsAppQRScanner';

export const WhatsApp: React.FC = () => {
  const [qrScannerVisible, setQrScannerVisible] = useState(true);
  return <>
  
  <WhatsAppQRScanner
        visible={qrScannerVisible}
        onClose={() => setQrScannerVisible(false)}
        onAuthenticated={() => {
          setQrScannerVisible(false);
          // Refresh accounts after authentication
          // if (selectedAccount) {
          //   fetchConversations(selectedAccount);
          // } else {
          //   fetchAccounts();
          // }
        }}
      />
  </>;
};

